import axios from 'axios'
import config from './config'


export default {

    execute(file, fileName, bucket) {
        console.log(file.name)
        console.log(fileName)
        if (file.type != 'application/pdf'
            &&  file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            && file.type != 'application/vnd.ms-excel' && file.size < 2100000) {
            file.type = ''; //make it fail on submission to service below if not an approved file type and if not, just over, 2MB
            // this won't message end user but they had to hack to get this far
        }
        const payload = {
            bucketName: bucket,
            filePath: fileName,
            contentType: file.type
        };

        return axios.post(config.HEPDATAPORTAL_API_ENDPOINT + "getSignedUrl", payload)
            .then((res) => {
                console.log("execute signedurl")

                return Promise.resolve(res.data || '/')
            })
            .catch((err) => {
                return Promise.reject('/')
            });
    },

    searchTerm(searchIt) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "getSearchResults", '{"searchIt":'+'"'+searchIt+'"}')
            .then((res) => {
            return Promise.resolve(res.data)
        })
    .catch(e => {
            console.log(e);
    });
    },

    getDemography(id, username, fullName) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "getDemography", '{"id":'+'"'+id+'","username":'+'"'+username+'","fullName":'+'"'+fullName+'"}')
            .then((res) => {
            return Promise.resolve(res.data)
        })
    .catch(e => {
            console.log(e);
    });
    },

    confirmPlan(id, username, fullName) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "confirmPlan", '{"id":'+'"'+id+'","username":'+'"'+username+'","fullName":'+'"'+fullName+'"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },

    proceedToContact(id, username, userEmail) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "proceedToContact", '{"id":'+'"'+id+'","username":'+'"'+username+'","userEmail":'+'"'+userEmail+'"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },

    getCourtesyContacts(id, username) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "getCourtesyContacts", '{"id":'+'"'+id+'","username":'+'"'+username+'"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },

    searchContactsByEmailAndContactTypeId(email, contactTypeId) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "searchContacts", '{"email":' + '"' + email + '","contactTypeId":' + '"' + contactTypeId + '"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },

    searchContacts(email) {
        return axios.post(`${process.env.VUE_APP_API_BASE_URL}/` + "searchContacts", '{"email":'+'"'+email+'"}')
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch(e => {
                console.log(e);
            });
    },

    letsPingIt() {
        return axios.get(config.HEPDATAPORTAL_API_ENDPOINT + "ping")
            .then((res) => {
             })
    .catch(e => {
            console.log(e);
    });
    },

    pingEndpoint() {
        return axios.get(`${process.env.VUE_APP_API_BASE_URL}/` + "ping")
            .then((res) => {
             })
    .catch(e => {
            console.log(e);
    });
    }

}

